import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutsModule } from 'src/app/layouts/layouts.module';
import { UserDashboardComponent } from './dashboard/user-dashboard.component';
import { userPages } from './user.routes';
import { UserStammdatenComponent } from './stammseite/stammdaten.component';
import { UserCreateComponent } from './create/user-create.component';
import { UserEditComponent } from '@app/pages/user/edit/user-edit.component';
import { AuthGuard } from '@app/components/cleanui/system/Guard/auth.guard';
import { UserProjectRolesComponent } from '@app/pages/user/project-roles/user-project-roles.component';
import { PrivacyGuard } from '@app/components/cleanui/system/Guard/privacy.guard';

// Userseiten - User Pages

export const userRoutes: Routes = [
	{
		path: userPages.dashboard.url,
		component: UserDashboardComponent,
		canActivate: [AuthGuard, PrivacyGuard],
		data: {
			title: 'person.user',
			permissions: ['users:read', 'project-users:read'],
		}
	},
	{
		path: userPages.stammDaten.url,
		component: UserStammdatenComponent,
		canActivate: [AuthGuard, PrivacyGuard],
		data: {
			title: 'person.user',
			permissions: ['users:read'],
		}
	},
	{
		path: userPages.create.url,
		component: UserCreateComponent,
		canActivate: [AuthGuard, PrivacyGuard],
		data: {
			title: 'person.user',
			permissions: ['users:create'],
		}
	},
	{
		path: userPages.edit.url,
		component: UserEditComponent,
		canActivate: [AuthGuard, PrivacyGuard],
		data: {
			title: 'person.user',
			permissions: ['users:read', 'project-users:read'],
		}
	},
	{
		path: userPages.projectRoles.url,
		component: UserProjectRolesComponent,
		canActivate: [AuthGuard, PrivacyGuard],
		data: {
			title: 'person.user',
			permissions: ['users:read', 'project-users:read'],
		}
	},
];

@NgModule({
	imports: [LayoutsModule, RouterModule.forChild(userRoutes)],
	providers: [],
	exports: [RouterModule]
})
export class UserRouterModule {}
